<template>
  <div id="app">
    <FindField/>
  </div>
</template>

<script>
import FindField from './components/FindField.vue'

export default {
  name: 'App',
  components: {
    FindField
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
